export const VERIFICATION_SERVER_URL = 'https://d2kqfqjue90fhz.cloudfront.net';
export const MV_BASIC_ENCRYPTION_KEY = 43;
export const VERIFICATION_COMPLETE_ROUTE = '/vc';
export const INIT_SESSION_ROUTE = '/sv';
export const SUPPLIER_REDIRECT_ROUTE = '/dv';
export const DEBUG_LOGS_ROUTE = '/se';
